import { FC, PropsWithChildren } from 'react';

import type { StoredCoordinates } from '@payaca/helpers/locationHelper';
import { getGoogleMapsSearchUrlForAddress } from '@payaca/helpers/locationHelper';
import type { Nullish } from '@payaca/utilities/types';

export interface IProps {
  addressText?: Nullish<string>;
  coordinates?: Nullish<StoredCoordinates>;
  onClick?: (e: any) => void;
}

const GoogleMapAnchor: FC<PropsWithChildren<IProps>> = (props) => {
  const { addressText, coordinates, children, onClick } = props;

  const mapUrl = getGoogleMapsSearchUrlForAddress(coordinates, addressText);

  if (!mapUrl) {
    return <>{children}</>;
  }

  return (
    <a
      href={mapUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {children}
    </a>
  );
};

export default GoogleMapAnchor;
